import { useEffect, useState } from 'react';
import { SecureChatMessageLogService } from '../../../services/secureChatMessageLogService';
import AnimateLoader from "../../shared/loaders/animate-loader.component";
import messagsLogsLoader from "../../shared/loaders/message-logs-search-inprogress-loader.json";

interface Props {
    more?: boolean;
    Media: any[];
    text?: boolean;
    mediaDisplay?: () => void;
    fileDownload?: () => void;
    classname?: any;
}

const SecureChatMediaViewComponent = (props: Props) => {
    const [Media, SetMedia] = useState([]);
    const [whRatio, SetWhRatio] = useState(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true)
        SecureChatMessageLogService.getMediaFileBase64Data({ media: props.Media }).then(res => {
            SetMedia(res.data);
            setIsLoading(false)
        });
    }, [props.Media])

    const downloadBase64File = (base64Data, fileName) => {
        const response = fetch(base64Data);

        response
            .then(res => res.blob())
            .then(blob => {
                const url = URL.createObjectURL(blob);

                const a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);

                a.click();

                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            });

    }

    return (
        <div className='d-flex justify-center align-center'>
            {
                isLoading
                    ?
                    <AnimateLoader LoaderAnimation={messagsLogsLoader} className='w-20 mb-4' />
                    :
                    Media.map(x => {
                        return (
                            <div className='w-p-100 br-2 d-flex flex-direction justify-center align-center custom-text-field-border'>
                                {x.file_type.includes("image") ? (
                                    whRatio < 1 ? <img src={x.value} className={props.classname} style={{ backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover" }} /> :
                                        <img src={x.value} className={props.classname} style={{ backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "contain" }} />
                                )
                                    :
                                    x.file_type.includes("video") &&
                                    <video controls={true} controlsList="nodownload" src={x.value} className={`display-video media mb-2`} />
                                }
                                <div className='h5-medium color-primary-light t-underline c-pointer mb-3' onClick={() => downloadBase64File(x.value, x.file_name)}>
                                    Download
                                </div>
                            </div>
                        )
                    })
            }
        </div>
    )
}

export default SecureChatMediaViewComponent;


